import { IconButton } from "@mui/material";
import { useContext, useEffect } from "react";
import { colorChangeOfMetal } from "../../utils/commonUtils.js/commonFunc";
import * as THREE from "three";
import stateContext from "../../Context/StateContext";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../api/client";

const MetalStyle = ({ activeIndex, setActiveIndex }) => {
    const globalState = useContext(stateContext);

    // const metalDataQuery = useQuery({
    //     queryKey: ["metalData"],
    //     queryFn: () => apiClient.get("/metals"),
    // });

    // const metalData = metalDataQuery.data?.data || [];

    const handleColorChange = (metal, index) => {
        setActiveIndex(index);
        colorChangeOfMetal(new THREE.Color(metal.color), globalState);
        globalState.setSelectedMetalData(metal);
    };

    return (
        <>
            <div className="tabpanel__content-boxes">
                {globalState.allMetalData.map((metal, index) => {
                    const isAvailable = metal.status === "Available";
                    return (
                        <div
                            key={index}
                            className={`tabpanel__content-box ${
                                activeIndex === index ? "active" : ""
                            }`}
                        >
                            <IconButton
                                className="inheritMuiIconButton"
                                onClick={() => handleColorChange(metal, index)}
                                disabled={!isAvailable}
                                style={{
                                    color: !isAvailable ? "#b5b5b5" : "",
                                    cursor: !isAvailable
                                        ? "not-allowed"
                                        : "pointer",
                                    opacity: !isAvailable ? 0.5 : 1,
                                    backgroundColor: !isAvailable
                                        ? "#f0f0f0"
                                        : "",
                                }}
                            >
                                <span className="inheritMuiIconButton-container">
                                    <span
                                        className="tabpanel__content-box-icon tabpanel__content-box-icon--48"
                                        style={{
                                            backgroundColor: metal.color,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            borderRadius: "50%",
                                        }}
                                    >
                                        <span
                                            className="tabpanel__content-box-label"
                                            style={{
                                                textAlign: "center",
                                                width: "100%",
                                            }}
                                        >
                                            {metal.label}
                                        </span>
                                    </span>
                                    <span className="tabpanel__content-box-label">
                                        {globalState.selectedFontLanguage ===
                                        "English"
                                            ? metal.name
                                            : metal.arabicName
                                            ? metal.arabicName
                                            : metal.name}
                                    </span>
                                    {!isAvailable && (
                                        <span style={{ fontSize: "12px" }}>
                                            {metal.status.replace(/_/g, " ")}
                                        </span>
                                    )}
                                </span>
                            </IconButton>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default MetalStyle;
